"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _termsModule = require("./termsModule");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var createHTMLMarkup = function createHTMLMarkup(html) {
  return {
    __html: html
  };
};

var TermsPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TermsPage, _React$Component);

  function TermsPage() {
    _classCallCheck(this, TermsPage);

    return _possibleConstructorReturn(this, _getPrototypeOf(TermsPage).apply(this, arguments));
  }

  _createClass(TermsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.fetchLOAContent();
    }
  }, {
    key: "render",
    value: function render() {
      var loaHtml = this.props.loaHtml;
      var re = /<style>\s+(.*)\s+<\/style>/;
      loaHtml = loaHtml && loaHtml.replace(re, '$1');
      return _react.default.createElement("div", {
        style: {
          padding: '20px',
          fontSize: '1.2em',
          lineHeight: '1.6'
        },
        dangerouslySetInnerHTML: createHTMLMarkup(loaHtml)
      });
    }
  }]);

  return TermsPage;
}(_react.default.Component);

TermsPage.propTypes = {
  fetchLOAContent: _propTypes.default.func.isRequired
};

function mapStateToProps(state) {
  var _state$terms = state.terms;
  _state$terms = _state$terms === void 0 ? {} : _state$terms;
  var _state$terms$loa$cont = _state$terms.loa.content;
  _state$terms$loa$cont = _state$terms$loa$cont === void 0 ? {} : _state$terms$loa$cont;
  var loaHtml = _state$terms$loa$cont.html;
  return {
    loaHtml: loaHtml
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchLOAContent: _termsModule.fetchLOAContent
})(TermsPage);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/terms/TermsPage.js
// module id = 276
// module chunks = 0